import React, { useState, useEffect } from 'react';
import {
  TextField,
  MenuItem,
  Button,
  Typography,
  Grid,
  Container,
  Paper,
  Box,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Star } from '@mui/icons-material';
import StarIcon from '@mui/icons-material/Star';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import CryptoJS from 'crypto-js';


const StyledStar = styled(StarIcon)(({ theme, selected }) => ({
  cursor: 'pointer',
  color: selected ? '#FFD700' : '#e0e0e0', // Gold for selected, grey for unselected
  fontSize: '32px',
  transition: 'color 0.3s ease, transform 0.3s ease',
  '&:hover': {
    color: '#FFA500', // Change color on hover
    transform: 'scale(1.2)', // Slightly enlarge on hover
  },
}));


const RatingCategory = ({ label, ratingName, formData, handleChange }) => (
  <Grid item xs={12} sm={4}>
    <Typography
      variant="subtitle1"
      fontWeight="bold"
      gutterBottom
      sx={{ textAlign: 'center', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#3f51b5' }}
    >
      {label}
    </Typography>
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {[1, 2, 3, 4, 5].map((rating) => (
          <Tooltip
            key={rating}
            title={`${rating} Star${rating > 1 ? 's' : ''}`}
            placement="top"
            arrow
          >
            <StyledStar
              selected={formData[ratingName] >= rating}
              onClick={() => handleChange({ target: { name: ratingName, value: rating.toString() } })}
            />
          </Tooltip>
        ))}
      </Box>
      <Typography variant="caption" sx={{ marginTop: '8px', color: '#757575' }}>
        {formData[ratingName] ? `You rated: ${formData[ratingName]}/5` : 'No rating selected'}
      </Typography>
    </Box>
  </Grid>
);


// Styled Paper component for better visual appeal
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.common.white,
  boxShadow: theme.shadows[10], // Increased shadow for more depth
  borderRadius: theme.shape.borderRadius * 2, // Rounded corners
  opacity: 0.9, // Slightly transparent for a better blend with background
  minHeight: '85vh',
}));

// Styled container for background image
const BackgroundContainer = styled(Container)(({ theme }) => ({
  minHeight: '100vh',
  padding: '20px',
  backgroundImage: 'url(/feedback_background.jpg)',
  // backgroundImage: 'url(https://c4.wallpaperflare.com/wallpaper/473/417/75/line-abstraction-samsung-galaxy-s5-wallpaper-preview.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  maxWidth: 'none', // Removes default max-width

  // Apply custom styles for large screens
  [`@media (min-width: 1200px)`]: {
    maxWidth: 'none', // Remove the 1200px max-width constraint
  },
}));


const ClientFeedbackForm = () => {



  const [decryptedId, setDecryptedId] = useState(null);
  const location = useLocation();



  console.log("decryptedId--------------", decryptedId)






  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const encryptedIdFromUrl = queryParams.get('id'); // Extract the encrypted ID from the URL
    console.log("encryptedIdFromUrl--------------", encryptedIdFromUrl);

    if (encryptedIdFromUrl) {
      // Remove any spaces in the encrypted ID
      const cleanedEncryptedId = encryptedIdFromUrl.replace(/\s+/g, '+');

      const secretKey = 'your'; // Use the same secret key used for encryption
      const bytes = CryptoJS.AES.decrypt(cleanedEncryptedId, secretKey); // Decrypt the ID
      const originalId = bytes.toString(CryptoJS.enc.Utf8); // Convert to UTF-8 string
      console.log("originalId--------------", originalId); // Log the decrypted ID

      // Check if the decrypted ID is valid
      if (originalId) {
        setDecryptedId(originalId); // Save the decrypted ID in state
      } else {
        console.error('Decryption failed: Invalid ID');
      }
    } else {
      console.error('No encrypted ID found in URL');
    }
  }, [location.search]);





  const [formData, setFormData] = useState({
    company_name: '',
    demo_product: '',
    presentation_rating: '',
    product_interest_rating: '',
    feature_relevance_rating: '',
    positive_feedback: '',
    improvement_suggestions: '',
    additional_features_requested: '',
    meeting_outcome: '',
    follow_up_action: '',
    overall_comments: '',
    submitted_by: '',
  });

  const isFormValid = () => {
    const requiredFields = [
      'presentation_rating',
      'product_interest_rating',
      'feature_relevance_rating',
      'demo_product',
      'meeting_outcome',
      'submitted_by'

    ];

    return requiredFields.every((field) => formData[field] !== '');
  };

  const meetingOutcomeChoices = [
    { value: 'interested', label: 'Interested' },
    { value: 'undecided', label: 'Undecided' },
    { value: 'not_interested', label: 'Not Interested' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Submit form data to your backend API
    try {
      const response = await fetch('/api/post-feedback/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      console.log('Feedback submitted successfully', formData);

      if (response.ok) {
        console.log('Feedback submitted successfully', formData);
        // Optionally, reset the form or show a success message
        setFormData({
          // company_name: '',
          demo_product: '',
          presentation_rating: '',
          product_interest_rating: '',
          feature_relevance_rating: '',
          positive_feedback: '',
          improvement_suggestions: '',
          additional_features_requested: '',
          meeting_outcome: '',
          follow_up_action: '',
          overall_comments: '',
          submitted_by: '',
        });
      } else {
        console.error('Error submitting feedback');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };


  useEffect(() => {
    // Only fetch the company name if decryptedId is available
    if (decryptedId) {
      fetchCompanyName();
    }
  }, [decryptedId]);

  const fetchCompanyName = async () => {
    try {
      const response = await fetch(`http://42.0.0.1:8001/client-enquiry/${decryptedId}/`);
      if (response.ok) {
        const data = await response.json();
        setFormData((prevData) => ({
          ...prevData,
          company_enquiry: data.id,
          company_name: data.company_name, // Assuming 'company_name' is the key in the response
        }));
      } else {
        console.error('Failed to fetch company name');
      }
    } catch (error) {
      console.error('Error fetching company name:', error);
    }
  };


  return (
    <BackgroundContainer>
      <StyledPaper elevation={3}>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 'bold', // Make the text bold
            color: '#3f51b5', // Change the color (e.g., primary color)
            marginBottom: '10px', // Add margin for spacing
            textTransform: 'uppercase', // Uppercase text for emphasis
            letterSpacing: '1px', // Add letter spacing
          }}
        >
          Client Feedback Form
        </Typography>


        <form onSubmit={handleSubmit} style={{ maxHeight: '635px' }}>
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Company Name"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                required
                variant="outlined"
                InputProps={{
                  readOnly: true, // Makes the field non-editable
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Demo Product"
                name="demo_product"
                value={formData.demo_product}
                onChange={handleChange}
                required
                variant="outlined"
              />
            </Grid>





            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Meeting Outcome"
                name="meeting_outcome"
                value={formData.meeting_outcome}
                onChange={handleChange}
                required
                variant="outlined"
              >
                {meetingOutcomeChoices.map(({ value, label }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Submitted By"
                name="submitted_by"
                value={formData.submitted_by}
                onChange={handleChange}
                required
                variant="outlined"
              />
            </Grid>



            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Positive Feedback"
                name="positive_feedback"
                value={formData.positive_feedback}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Improvement Suggestions"
                name="improvement_suggestions"
                value={formData.improvement_suggestions}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Additional Features Requested"
                name="additional_features_requested"
                value={formData.additional_features_requested}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Follow-up Action"
                name="follow_up_action"
                value={formData.follow_up_action}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Overall Comments"
                name="overall_comments"
                value={formData.overall_comments}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>





            {/* Ratings */}
            <RatingCategory
              label="Presentation Rating"
              ratingName="presentation_rating"
              formData={formData}
              handleChange={handleChange}
            />
            <RatingCategory
              label="Product Interest Rating"
              ratingName="product_interest_rating"
              formData={formData}
              handleChange={handleChange}
            />
            <RatingCategory
              label="Feature Relevance Rating"
              ratingName="feature_relevance_rating"
              formData={formData}
              handleChange={handleChange}
            />


            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="primary" disabled={!isFormValid()} fullWidth>
                Submit Feedback
              </Button>
            </Grid>
          </Grid>
        </form>
      </StyledPaper>
    </BackgroundContainer>
  );
};

export default ClientFeedbackForm;
